<mat-card class="location-context">
  <mat-card-content>
      <!-- Title -->
      <h1 data-cy="title">Terminal Selection</h1>
      
      <!-- Terminal Selection -->
      <div class="intro">
        <span>Select the terminal to work on</span>
      </div>
      <div class="buttons">
        <div class="button" *ngFor="let terminal of terminals">
          <button mat-raised-button color="primary" (click)="setSelectedTerminalAndRedirect(terminal, false)" data-cy="terminal">
            {{ terminal }}
          </button>
        </div>
      </div>
  </mat-card-content>
</mat-card>